module.exports = __webpack_public_path__ + "img/Monte_Kope_sauna_2.0bf056d3.jpg";